module.exports = __webpack_public_path__ + "img/server.252efe2a.svg";